import styled from "styled-components";

const CommonCell = ({ children, styles, styleProps }) => {
  return (
    <CellWrap $styleProps={styleProps} style={styles}>
      {children}
    </CellWrap>
  );
};

const CellWrap = styled.div`
  width: 71px;
  min-width: 71px;
  height: 21px;
  display: flex;
  justify-content: center;
  background-color: #fff;

  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  align-items: center;
  padding: 3px;
  font-size: 13px;
  ${p => p.styleProps}
`;

export default CommonCell;
